import { Injectable } from '@angular/core';
import { Subject, debounce, interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SizeNotifierService {
  private _elementHeight: number;

  public set elementHeight(value: number) {
    this._elementHeight = value;
    this._elementHeightChanged.next(this._elementHeight);
  }

  private readonly _elementHeightChanged: Subject<number> = new Subject<number>();

  /**
   * Observable that emits the height of the element that is being observed
   *
   * @readonly
   * @memberof SizeNotifierService
   */
  public get elementHeightChanged() {
    //debounce the event to prevent multiple events from being fired in rapid succession
    return this._elementHeightChanged.pipe(debounce(i => interval(100)));
  }
}
